{
  "name": "@peanuts/vue-frontend",
  "description": "Peanuts Frontend Application",
  "homepage": "https://app.peanuts.nl",
  "version": "1.79.18",
  "private": true,
  "type": "module",
  "engines": {
    "node": ">=22 <=22.23.2"
  },
  "scripts": {
    "dev": "vite --host",
    "dev:acceptance": "vite --mode acceptance",
    "dev:capacitor": "vite --mode capacitor",
    "dev:production": "vite --mode production --host",
    "build": "run-s \"build-only {@}\" type-check --",
    "build-no-minify": "run-s \"build-only-no-minify {@}\" type-check --",
    "build-only": "vite build",
    "build-only-no-minify": "vite build --minify false",
    "preview": "vite preview",
    "test:unit": "vitest",
    "test:e2e": "playwright test --project chromium --ui",
    "test:storybook:e2e": "playwright test --config e2e/storybook/playwright.config.ts",
    "type-check": "vue-tsc --build",
    "lint": "eslint . --fix",
    "format": "prettier --write src/",
    "format:check": "prettier --list-different src/",
    "storybook": "storybook dev -p 6006",
    "build-storybook": "storybook build",
    "generate:sdk": "npx @openapitools/openapi-generator-cli generate -i http://localhost:8000/d/api/schema/ -g typescript-axios -o sdk && node -e \"require('fs').rmSync('sdk/docs', { recursive: true, force: true })\"",
    "postinstall": "patch-package",
    "prepare": "cd .. && husky vue-frontend/.husky"
  },
  "lint-staged": {
    "**/*.{vue,js,jsx,cjs,mjs,ts,tsx,cts,mts}": [
      "eslint --fix",
      "prettier --write"
    ]
  },
  "dependencies": {
    "@capacitor-community/file-opener": "^8.0.1",
    "@capacitor-community/safe-area": "^8.0.1",
    "@capacitor-firebase/messaging": "^8.5.2",
    "@capacitor/android": "^8.6.0",
    "@capacitor/app": "^8.1.2",
    "@capacitor/app-launcher": "^8.0.1",
    "@capacitor/core": "^8.6.0",
    "@capacitor/dialog": "^8.0.1",
    "@capacitor/file-transfer": "^2.0.6",
    "@capacitor/filesystem": "^8.1.5",
    "@capacitor/geolocation": "^8.2.4",
    "@capacitor/ios": "^8.6.0",
    "@capacitor/local-notifications": "^8.3.1",
    "@capacitor/push-notifications": "^8.1.3",
    "@capacitor/splash-screen": "^8.0.2",
    "@capawesome/capacitor-app-update": "^8.1.1",
    "@capgo/capacitor-updater": "^8.54.0",
    "@clerk/localizations": "^4.24.4",
    "@clerk/vue": "^2.5.17",
    "@fortawesome/fontawesome-svg-core": "^7.3.1",
    "@fortawesome/free-brands-svg-icons": "^7.3.1",
    "@fortawesome/free-regular-svg-icons": "^7.3.1",
    "@fortawesome/free-solid-svg-icons": "^7.3.1",
    "@fortawesome/vue-fontawesome": "^3.3.3",
    "@googlemaps/js-api-loader": "^2.1.3",
    "@iconify-json/lucide": "^1.2.150",
    "@interactjs/actions": "^1.10.28",
    "@interactjs/auto-start": "^1.10.28",
    "@interactjs/interact": "^1.10.27",
    "@internationalized/date": "^3.12.4",
    "@microsoft/applicationinsights-web": "^3.4.5",
    "@mindlib-capacitor/send-intent": "^8.0.6",
    "@nuxt/ui": "^4.12.0",
    "@regle/core": "^1.29.5",
    "@regle/rules": "^1.29.5",
    "@sentry/capacitor": "~4.3.0",
    "@sentry/vue": "10.69.0",
    "@tailwindcss/vite": "^4.3.4",
    "@tanstack/charts": "^1.2.1",
    "@tanstack/vue-table": "^8.21.3",
    "@tanstack/vue-virtual": "^3.13.51",
    "@thegrizzlylabs/web-geniusscan-sdk": "^6.6.0",
    "@transistorsoft/capacitor-background-fetch": "^8.1.3",
    "@transistorsoft/capacitor-background-geolocation": "^9.7.2",
    "@types/uuid": "^10.0.0",
    "@vue/devtools-api": "^8.2.1",
    "@vuepic/vue-datepicker": "^13.0.0",
    "@vueuse/components": "^15.0.0",
    "@vueuse/core": "^15.0.0",
    "@vueuse/integrations": "^15.0.0",
    "@zoom-image/vue": "^0.2.34",
    "axios": "^1.21.0",
    "capacitor-native-settings": "^8.2.0",
    "centrifuge": "^5.8.0",
    "core-js": "^3.51.0",
    "date-fns": "^4.4.0",
    "dompurify": "^3.4.17",
    "file-type": "^22.3.0",
    "firebase": "^12.19.0",
    "fuse.js": "^7.5.0",
    "html2canvas-pro": "2.5.0",
    "i18n-iso-countries": "^7.14.0",
    "jspdf": "^4.2.1",
    "leaflet": "^1.9.4",
    "lodash-es": "^4.18.1",
    "marked": "^18.1.3",
    "maska": "^3.2.2",
    "mitt": "^3.0.1",
    "moment": "^2.31.0",
    "odata-query": "^8.1.0",
    "patch-package": "^8.0.1",
    "pinia": "^4.1.0",
    "register-service-worker": "^1.7.2",
    "reka-ui": "^2.11.0",
    "sortablejs": "^1.15.7",
    "uuid": "^14.0.3",
    "vue": "^3.5.44",
    "vue-router": "^5.4.0"
  },
  "devDependencies": {
    "@capacitor/assets": "^3.0.5",
    "@capacitor/cli": "^8.6.0",
    "@clerk/testing": "^2.2.53",
    "@openapitools/openapi-generator-cli": "^2.42.0",
    "@playwright/test": "^1.64.1",
    "@semantic-release/changelog": "^7.0.0",
    "@semantic-release/exec": "^7.1.0",
    "@semantic-release/git": "^11.0.1",
    "@sentry/vite-plugin": "^5.4.1",
    "@storybook/addon-docs": "^10.6.5",
    "@storybook/addon-mcp": "^10.6.5",
    "@storybook/addon-onboarding": "^10.6.5",
    "@storybook/vue3-vite": "^10.6.5",
    "@tailwindcss/forms": "^0.5.11",
    "@tsconfig/node22": "^22.0.6",
    "@types/google.maps": "^3.66.9",
    "@types/jsdom": "^30.0.0",
    "@types/leaflet": "^1.9.22",
    "@types/lodash-es": "^4.17.12",
    "@types/node": "^22.20.5",
    "@types/sortablejs": "^1.15.9",
    "@vitejs/plugin-vue": "^6.0.10",
    "@vitest/eslint-plugin": "^1.6.28",
    "@vue/compiler-sfc": "^3.5.43",
    "@vue/eslint-config-prettier": "^10.2.0",
    "@vue/eslint-config-typescript": "^14.9.0",
    "@vue/test-utils": "^2.5.1",
    "@vue/tsconfig": "^0.9.1",
    "dotenv": "^18.0.9",
    "eslint": "^9.39.5",
    "eslint-plugin-playwright": "^2.12.2",
    "eslint-plugin-storybook": "^10.6.5",
    "eslint-plugin-vue": "^10.12.0",
    "husky": "^9.1.7",
    "jsdom": "^30.1.3",
    "lint-staged": "^17.6.0",
    "npm-run-all2": "^9.0.4",
    "prettier": "^3.9.10",
    "prettier-plugin-tailwindcss": "^0.8.1",
    "sass": "^1.107.1",
    "semantic-release": "^25.0.9",
    "start-server-and-test": "^3.0.13",
    "storybook": "^10.6.5",
    "tailwindcss": "^4.3.4",
    "tsc-files": "^1.1.4",
    "typescript": "^6.0.3",
    "vite": "^8.3.5",
    "vite-plugin-mkcert": "^2.1.0",
    "vite-plugin-pwa": "^2.0.0",
    "vite-plugin-vue-devtools": "^8.2.1",
    "vitest": "^5.1.0",
    "vue-tsc": "^3.3.14"
  }
}
